import { styled } from 'styled-components';

export const PlayerStatsTableWrapper = styled.div`
  > div > div {
    background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  }
`;

PlayerStatsTableWrapper.displayName = 'PlayerStatsTableWrapper';

export const PlayerStatsPagination = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing.small};
  align-items: center;
  padding: 0 ${({ theme }) => theme.sizing.medium}
    ${({ theme }) => theme.sizing.medium};

  > div:first-child {
    margin-left: auto;
  }

  ol {
    gap: ${({ theme }) => theme.sizing.small};
  }
`;

PlayerStatsPagination.displayName = 'PlayerStatsPagination';
